import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    width: "100%",
  },
  labelName: {
    fontFamily: "VodafoneRg-bold",
    margin: "1rem 0",
    fontSize: "1.5rem",
    textAlign: "left",
    color: "#333",
    display: "block",
  },
}));

const ChallengeOrganizerList = ({
  challengeOrganizerEmailList = [],
  className = "ds",
  title = "Challenge Organizer Email List : ",
}) => {
  const classes = useStyles();


  const sortedEmails = [...challengeOrganizerEmailList].sort((a, b) =>
  a.localeCompare(b, undefined, { sensitivity: "base" })
);


  return (
    <div>
      <h3 className={classes.labelName}>{title}</h3>

      <List className={className}>
        {challengeOrganizerEmailList.length === 0 ? (
          <ListItemText primary="No emails found" />
        ) : (
            sortedEmails.map((email, index) => (
            <ListItem key={email}>
              <ListItemAvatar>
                <Avatar>
                  {email?.[0]?.toUpperCase() || "?"}
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={email} />
            </ListItem>
          ))
        )}
      </List>
    </div>
  );
};

export default React.memo(ChallengeOrganizerList);
